import { useMutation } from '@northladder/services';
import {
  IApiError,
  ErrorEventsEnum,
  errorLogToRemoteUtil,
} from '@northladder/utilities';

import { USER_ACCOUNTS_API } from '../userAccountsAPIClient';

/**
 * This is to track the profile update mutation keys in react query cache.
 */
const MUT_USER_PROFILE_UPDATE = 'user-profile-update';

interface IUserProfileUpdateOptions {
  onSuccessCallback: () => void;
}

/**
 * This performs a profile update request. It takes the user's updated profile
 * information including firstName, lastName, phoneNumber, and displayPicture.
 */
export const useUserProfileUpdateMutation = ({
  onSuccessCallback,
}: IUserProfileUpdateOptions) => {
  const { error, isPending, mutate } = useMutation({
    mutationKey: [MUT_USER_PROFILE_UPDATE],
    networkMode: 'always',
    retry: false,
    mutationFn: USER_ACCOUNTS_API.userProfileUpdate,
    onSuccess: () => {
      onSuccessCallback();
    },
    onError: (err: IApiError) => {
      errorLogToRemoteUtil({
        error,
        errorCode: ErrorEventsEnum.ERROR_IN_API_CALL,
        errorTitle: 'useUserProfileUpdateMutation Error',
        message: err.message,
      });

      return err;
    },
  });

  return {
    error,
    isPending,
    updateProfile: mutate,
  };
};
